import React from 'react';
import { Col, Container, Row ,  Card} from 'react-bootstrap';
import './Gallery.css';
import Banner from '../Banner/Banner'
import 'bootstrap/dist/css/bootstrap.min.css';
import img0 from '../../../../Images/g0.jpeg';
import img1 from '../../../../Images/g1.jpeg';
import img2 from '../../../../Images/g2.jpeg';
import img3 from '../../../../Images/g3.jpeg';
import img4 from '../../../../Images/g4.jpeg';
import img5 from '../../../../Images/g5.jpeg';
import img6 from '../../../../Images/g6.jpeg';
import img7 from '../../../../Images/g7.jpeg';
import img8 from '../../../../Images/g8.jpeg';

const Gallery = () => {

    const ImageData = [
        {
            image : img0
        },    
        {
            image : img1
        }, 
        {
            image : img2
        },
        {
            image : img8
        },
        {
            image : img3
        },
        {
            image : img4
        },
        {
            image : img5
        },
        {
            image : img6
        },
        {
            image : img7
        },       
        
        
        ];
        
        
    const Videolinks = [
        
        {
            link : "https://www.youtube.com/embed/SSTXq-8R9Jo",
            title : "Physiotherapy Two Times Day at Savali Old Age Care"
        },
        {
            link : "https://www.youtube.com/embed/y4l-zsMR-20",
            title : "Supportive Staff at Savali Old Age Care"
        },
        {
            link : "https://www.youtube.com/embed/SSTXq-8R9Jo",
            title : "Physiotherapy Two Times Day at Savali Old Age Care"
        },       
        
        ];
    
    const renderVideoCard = (card , index) => {
        return(
            <>           
                <Col md={6} xl={4} lg={6} sm={12}>
                    <Card style={{ padding: '10px' , margin: '10px' }}>                
                        <div className="ratio ratio-16x9">
                            <iframe src={card.link} key={index} title={card.title} allowFullScreen></iframe>
                        </div>                                    
                    </Card>
                </Col>
            </>
        )
    };

    const renderImageCard = (card , index) => {
        return(
            <>           
                <Col md={6} xl={4} lg={6} sm={12}>
                    <Card style={{ padding: '10px' , margin: '10px' }}>                
                        <div className="ratio ratio-4x3">
                            <img src={card.image} key={index} alt={"img"+(index+1)} />
                        </div>                                    
                    </Card>
                </Col>
            </>
        )
    };

    return (
        <>  
            <Banner />
            <Container style={{marginTop: "30px"}}>
                <h1>Images</h1>
                <Row>                    
                    {ImageData.map(renderImageCard)}                     
                </Row>        
            </Container>           
            <Container style={{marginTop: "30px"}}>
                <h1>Videos</h1>
                <Row>                    
                    {Videolinks.map(renderVideoCard)}                     
                </Row>        
            </Container>  
        </>
    );
};
export default Gallery;